<template functional>
  <img
    src="@/assets/images/incentive-video.jpg"
    :width="props.width"
    :class="data.staticClass"
    v-bind="data.attrs"
  />
</template>
<script>
export default {
  name: 'VideoIncentive',
  props: {
    width: {
      type: [String, Number],
      default: '300'
    }
  }
}
</script>
